// bug929: verbatim copy from the CTO handoff (section 2) — the single home for this feature's strings.
// The backend returns the same no-match / phone-taken text; the page also falls back to these.

// Account Settings: "User Validation for Registration" block (under the QR code row).
export const USER_VALIDATION_HEADING = "User Validation for Registration";
export const USER_VALIDATION_OFF_LABEL = "No user validation";
export const USER_VALIDATION_OFF_DESC =
  "Anyone with the QR code can register after verifying their phone number.";
export const USER_VALIDATION_ON_LABEL = "Require user validation";
// Ticket 10/20 update: "uploaded" struck from the description.
export const USER_VALIDATION_ON_DESC =
  "Users must match an email or User ID in the user list to register.";
export const USER_VALIDATION_SAVE_FAILED =
  "We couldn't update user validation. Please try again.";
// Ticket NOTE 1 (10/20 update), verbatim; reads "1 user has" for a count of one.
export const buildValidationUserCountNote = (count) =>
  count === 1
    ? "Note 1 user has an Email and/or User ID available for validation."
    : `Note ${count} users have an Email and/or User ID available for validation.`;

// Registration page.
export const REGISTRATION_ALL_FIELDS = "Please enter all fields to register.";
export const REGISTRATION_EITHER_IDENTIFIER =
  "Please enter your first name, last name, phone number, and EITHER Email or User ID.";
export const REGISTRATION_NO_MATCH =
  "We could not match the information you entered. Please check them or contact your system administrator.";
export const REGISTRATION_PHONE_TAKEN = "This phone number is already registered.";
export const REGISTRATION_RATE_LIMITED =
  "Too many attempts. Please wait a moment and try again.";
export const EMAIL_PLACEHOLDER = "Email";
export const USER_ID_PLACEHOLDER = "User ID";
// Ticket 3.2.4 update (10/16), verbatim: an unmatched email with no User ID typed.
export const REGISTRATION_EMAIL_NOT_VALIDATED =
  "We couldn't validate your email. Please enter your Employee ID as well.";

export const buildRegistrationConsent = (companyName) =>
  `By submitting this form, I consent to receiving SMS text messages from ${companyName}. Msg & data rates may apply. I understand I may opt out at any time.`;

// Users list.
export const USER_ID_COLUMN_LABEL = "User ID";
export const USER_ID_SAVED_SUCCESS = "User ID saved successfully";
